<template>
    <b-container class="p-0">
        <component :is="Parameter.Type + 'Modal'" :Parameter="Parameter" :Variant="Variant" />
    </b-container>
</template>

<script lang="ts">
    import { Prop, Vue} from 'vue-property-decorator';
    import Component from 'vue-class-component';
    import Parameter from './Parameter';
    import FieldSet from './FieldSet';
    import VueI18n from 'vue-i18n' // translation support
    import locales from "./locales/ParametersItems.json";
    import FieldSetModal from './Modal/FieldSetModal.vue';
    import CheckBoxModal from './Modal/CheckBoxModal.vue';
    import ComboBoxModal from './Modal/ComboBoxModal.vue';
    import DateFieldModal from './Modal/DateFieldModal.vue';
    import GridPanelModal from './Modal/GridPanelModal.vue';
    import NumberModal from './Modal/NumberModal.vue';
    import RadioGroupModal from './Modal/RadioGroupModal.vue';
    import SpinnerModal from './Modal/SpinnerModal.vue';

    Vue.use(VueI18n);

    @Component({
        i18n: { messages: locales },
        components:{
            FieldSetModal,
            CheckBoxModal,
            ComboBoxModal,
            DateFieldModal,
            GridPanelModal,
            NumberModal,
            RadioGroupModal,
            SpinnerModal
        }
    })
	export default class ParametersModal extends Vue{
        /** Variant de couleur à appliquer sur le composant */
        @Prop({default: () => "secondary"})
		public Variant!: string;

        @Prop()
        public Parameter!: Parameter | FieldSet;
    }

</script>

<style scoped>
    :deep(input[type=checkbox]:checked) {
        /** Change la couleur de la checkbox */
        accent-color: var(--Variant) !important;
    }

    :deep(input[type=radio]:checked) {
        /** Change la couleur du bouton radio */
        accent-color: var(--Variant) !important;
    }

    /** Pour que la page active prenne en compte la couleur de Variant */
    :deep(.page-item.active .page-link) {
        background-color: var(--Variant) !important;
    }

    :deep(.page-link:hover) {
        background-color: var(--VariantLight) !important;
    }
</style>